"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SCROLL_PADDING_HEIGHT = exports.SCROLL_BUFFER_HEIGHT = void 0;
var react_1 = require("@emotion/react");
var material_1 = require("@mui/material");
exports.SCROLL_BUFFER_HEIGHT = 17;
exports.SCROLL_PADDING_HEIGHT = exports.SCROLL_BUFFER_HEIGHT + 20;
var makeScrollContainerStyling = function (_a) {
    var scrollBufferOffset = _a.scrollBufferOffset, scrollBufferOpacity = _a.scrollBufferOpacity;
    var mvf = (0, react_1.useTheme)().mvf;
    var palette = mvf.palette, filters = mvf.filters;
    return {
        scrollBox: (0, react_1.css)({
            height: '0px',
            width: '100%',
            display: 'flex',
            flex: '1 1 auto',
            overflowY: 'auto',
            overflowX: 'hidden',
            boxSizing: 'border-box',
            '&::-webkit-scrollbar': {
                width: '0.4em',
            },
            '&::-webkit-scrollbar-thumb': {
                backgroundColor: palette.component.answerUnselectedColor,
                borderRadius: 15,
            },
            '&::-webkit-scrollbar-track': {
                marginTop: 10,
                marginBottom: exports.SCROLL_PADDING_HEIGHT,
            },
            '& > .MuiContainer-root': {
                paddingLeft: 10,
                paddingRight: 10,
            },
        }),
        scrollPadding: (0, react_1.css)({
            width: '100%',
            height: exports.SCROLL_PADDING_HEIGHT,
        }),
        scrollBuffer: (0, react_1.css)({
            pointerEvents: 'none',
            width: '100%',
            top: scrollBufferOffset,
            height: exports.SCROLL_BUFFER_HEIGHT,
            opacity: scrollBufferOpacity,
            background: "linear-gradient(".concat((0, material_1.alpha)(palette.background.widgetBackgroundColor, filters.opacity.gentle), ", ").concat(palette.background.widgetBackgroundColor, ")"),
            boxShadow: '0px -8px 10px -3px rgba(0, 0, 0, 0.15);',
            position: 'absolute',
            justifyContent: 'center',
            transitionDuration: 'opacity 0.15s',
            zIndex: 2, // This should appear 'above' components such as Textfields
        }),
    };
};
exports.default = makeScrollContainerStyling;
//# sourceMappingURL=makeScrollContainerStyling.js.map